import { Icon, useDSContext } from '@edsn/ds';

export function Spinner() {
  const tokens = useDSContext();

  return (
    <div
      className="flex items-center justify-center bg-white px-3 py-16 lg:items-center"
      role="progressbar"
      aria-valuenow={0}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <Icon name={tokens.iconsLoader} className="h-16 w-16 animate-spin" />
    </div>
  );
}
